import { StageApiSdk } from "./StageApiSdk";

export const apiSdkInstance = new StageApiSdk();
